module.exports = __webpack_public_path__ + "img/56.b9945de9.svg";